import $ from 'jquery'

export default function initStickyTotals () {
    // var totals = $("#campaign__creative")
    // var footerOffset = $("#footerContainer").offset().top
    // var stoppedAt = null
    // var up = false
    // var maxDiff = $(".advertiser__container").height() - 45

    // $("#app").scroll(function(event){
    //     var newFooter = $("#footerContainer").offset().top
    //     var diff = footerOffset - newFooter
    //     var top = window.innerHeight + diff - 45

    //     if((totals.offset().top + 135 < newFooter || up) && top < maxDiff){
    //         up = false
    //         totals.css({"top": top + "px"})
    //     } else {
    //         totals.css({"top": maxDiff + "px"})
    //         if(!stoppedAt){
    //             stoppedAt = newFooter
    //             up = false
    //         } else if(newFooter > stoppedAt) {
    //             up = true
    //         }
    //     }
    // })
}